export const AppConfig = {
  name: import.meta.env.VITE_APP_NAME || "Kreoza",
  description: "We help creators create smarter.", // "Create smarter. Grow faster.",
  supportEmail: import.meta.env.VITE_SUPPORT_EMAIL || "support@kreoza.com",
  language: import.meta.env.VITE_APP_LANG || "en",
  version: import.meta.env.VITE_APP_VERSION || "1.0.0",
  BASE_URL: import.meta.env.VITE_APP_BASE_URL || "http://localhost:5173",

  environment: import.meta.env.MODE || "development", // dev, prod, etc
  defaultTheme: import.meta.env.VITE_THEME || "light", // light/dark/custom
  showDebugPanel: import.meta.env.VITE_SHOW_DEBUG === 'true',
  isBeta: import.meta.env.VITE_APP_BETA === 'true',
  GOOGLE_CLIENT_ID: "417642959759-gj3k48i4uqn3vjvrascsa0bqramn9opu.apps.googleusercontent.com",
  links: {
    "github": "https://github.com/kreoza",
    "tiktok": "https://www.tiktok.com/@kreoza_official",
    "instagram": "https://www.instagram.com/kreoza_official",
    "youtube": "https://www.youtube.com/@kreoza",
  },
  isComingSoonMode: import.meta.env.VITE_IS_COMING_SOON_MODE === 'true',
  isBetaMode: import.meta.env.IS_BETA_MODE === 'true' || false,
  isMaintenanceMode: import.meta.env.IS_MAINTENANCE_MODE === 'true' || false,
  isDevelopmentMode: import.meta.env.IS_DEVELOPMENT_MODE === 'true' || false,
  isProductionMode: import.meta.env.IS_PRODUCTION_MODE === 'true' || false,
  isTestingMode: import.meta.env.IS_TESTING_MODE === 'true' || false,
  isMockMode: import.meta.env.IS_MOCK_MODE === 'true' || false,
  isMockEnabled: import.meta.env.IS_MOCK_ENABLED === 'true' || false,
  isMockEnabledForDevelopment: import.meta.env.IS_MOCK_ENABLED_FOR_DEVELOPMENT === 'true' || false,
  isMockEnabledForProduction: import.meta.env.IS_MOCK_ENABLED_FOR_PRODUCTION === 'true' || false,
  isMockEnabledForTesting: import.meta.env.IS_MOCK_ENABLED_FOR_TESTING === 'true' || false,
  isMockEnabledForBeta: import.meta.env.IS_MOCK_ENABLED_FOR_BETA === 'true' || false,
  isMockEnabledForAlpha: import.meta.env.IS_MOCK_ENABLED_FOR_ALPHA === 'true' || false,
  isMockEnabledForGamma: import.meta.env.IS_MOCK_ENABLED_FOR_GAMMA === 'true' || false,
  isMockEnabledForProd: import.meta.env.IS_MOCK_ENABLED_FOR_PROD === 'true' || false,
  isMockEnabledForStaging: import.meta.env.IS_MOCK_ENABLED_FOR_STAGING === 'true' || false,
};
